<template>
  <v-container style="height: 100vh">
    <v-row align-content="center">
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-row align-content="center">
          <v-col>
            <h1 class="d-flex justify-center main-title center">404</h1>
          </v-col>
        </v-row>
        <v-row align-content="center">
          <v-col>
            <h3 class="d-flex justify-center second-title  center">Page non trouvée</h3>
          </v-col>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.main-title {
  font-size: 10vw;
  font-weight: lighter;
  color:rgb(15, 21, 71);
}
.second-title {
  font-size: 2vw;
  font-weight: lighter;
  color:rgb(15, 21, 71);
}
.center {
  float: none;
  margin: auto;
}
</style>
